import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
    getRegionalProjectIdRequest: ['response'],
    getRegionalProjectIdSuccess: ['response', 'loading'],
    getRegionalProjectIdFailure: ['error'],
})
export const getRegionalProjectIdTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: {},
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const getRegionalProjectIdSuccess = (state, { response }) =>
    state.merge({
        error: false,
        response,
        loading: false,
    })
const getRegionalProjectIdFailure = (state, { error }) =>
    state.merge({
        loading: false,
        error,
    })
const getRegionalProjectIdRequest = state =>
    state.merge({ loading: true, error: null })
export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_REGIONAL_PROJECT_ID_REQUEST]: getRegionalProjectIdRequest,
    [Types.GET_REGIONAL_PROJECT_ID_SUCCESS]: getRegionalProjectIdSuccess,
    [Types.GET_REGIONAL_PROJECT_ID_FAILURE]: getRegionalProjectIdFailure,
})
